import React, { useEffect, useState } from "react";
import "./OrderConfirmed.css";
 
import NewHeader from "../NewHeader/NewHeader";
import { Link } from "react-router-dom";
import { DesktopBack, BackToscreenIcon } from "./Cart";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
function OrderConfirmed(props) {
  const [customer, setCustomer] = useState("");
  const [bookId, setBookId] = useState();

  console.log("props ==========>", props);

  const location = useLocation();

  console.log("asdasd====> from" , location)
  const TransactionId = props.location?.state?.razorpay_payment_id;
  //getting data from localhost
  useEffect(() => {
    const patientDetails = JSON.parse(localStorage.getItem("customerDetails"));

    const bookingid = localStorage.getItem("bookingid");
    setBookId(bookingid && bookingid);
    console.log(bookingid, "BOOKIG ID");

    setCustomer(patientDetails && patientDetails);
    return () => {
      localStorage.removeItem("customerDetails");
      localStorage.removeItem("coupnCode");
    };
  }, []);
  return (
    <>
      <NewHeader />
      <div className="container">
        <DesktopBack title="Order Confirmed" currpath="or" />
      </div>
      <BackToscreenIcon title="Order Confirmed" currpath="or" />
      <div className=" container">
        <div className="container orderConfirmed">
          <div className="successImg">
            <img
              src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/928c1e0b-115d-4474-a51e-fb29d7d6e010.svg"
              alt="alternate img"
            />

            <div className="textcontent">
              <div className="successGreen textNeon">
                Your {location?.from =="/order" ? "Payment" : "Booking"}  is successful
              </div>
              {TransactionId && TransactionId !== "" ? (
                <div className="text-bold textGrey">
                  Transaction ID : {TransactionId}
                </div>
              ) : null}

              <div className="text-bold textGrey">
                Booking ID : {bookId && bookId !== "" && bookId}
              </div>
            </div>
          </div>
        </div>
        <div className="bookingButtons">
          <a href={`${process.env.RAZZLE_APP_BASE_URL}/dashboard/orders`}>
            <span className="btnprimary">Check Your Orders</span>
          </a>
          <a href={process.env.RAZZLE_APP_BASE_URL}>
            <span className="btn-light">Back To Home</span>
          </a>
        </div>
      </div>
    </>
  );
}

export default {
  component: OrderConfirmed,
};
